import { Component } from '@angular/core';
import { SearchmaskComponent } from 'searchmask-lib';
import { TranslateModule } from '@ngx-translate/core';
import { PimNotificationComponent } from 'core-lib';

@Component({
    selector: 'app-home',
    imports: [SearchmaskComponent, TranslateModule, PimNotificationComponent],
    templateUrl: './home.component.html',
    styleUrl: './home.component.scss'
})
export class HomeComponent {

}
